import { wrap } from '../wrap';
export function showShareButton() {
    wrap(function () {
        //if (window.webkit.messageHandlers && window.webkit.messageHandlers['showShareButton']) {
        if (window.Bridge && window.Bridge.postMessage) {
            //window.webkit.messageHandlers['showShareButton'].postMessage(['yes']);
            window.Bridge.postMessage({
                method: 'showShareButton',
                params: ['yes']
            });
            return true;
        }
        if (window.showShareButton) {
            window.showShareButton('yes');
            return true;
        }
        if (window.android && window.android.showShareButton) {
            window.android.showShareButton('yes');
            return true;
        }
        return false;
    });
}
export default showShareButton;
